import { ApiClient } from '@webapp/core/services/ApiClient'
import { CurrencyRepository } from './CurrencyRepository'

export const currencyRepository = new CurrencyRepository({
  httpClient: ApiClient,
})
